import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { Profession } from '../models/Profession'
import { ProfessionForm } from '../forms/ProfessionForm'
import { ProfessionFilter } from '../filters/ProfessionFilter'
import { ProfessionService } from '../services/ProfessionService'

export const useProfessionStore: KsStoreHook<Profession, ProfessionForm, ProfessionFilter> = createKsStore({
  id: 'professions',
  modelClass: Profession,
  formClass: ProfessionForm,
  filterClass: ProfessionFilter,
  service: ProfessionService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Profession #${item.id}`,
  signalREventName: 'ProfessionModel',
  isReferential: true
})
